import { DialogContent, DialogTitle, Stack } from "@mui/material";
import { materialGoodsReceiptBusiness } from "api/bussiness/material/material-goods-receipt";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { createMaterialOptionLabel } from "commons/ultilities/option-item/label-ultil";
import { observer } from "mobx-react-lite";
import { IUpdateMaterialGoodsReceipt } from "mobx-stores/_models/material-inventory/material-goods-receipt/material-goods-receipt";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect, useMemo } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getUpdateMaterialGoodsReceiptSchema } from "./schema";

export const UpdateMaterialGoodsReceipt = observer(() => {
  const {
    materialInventoryManagement: {
      materialGoodsReceiptStore: {
        openEdit,
        getMaterialGoodsReceipt,
        materialGoodsReceiptDetail,
        setProp,
      },
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
    setDefaults,
  } = useForm<IUpdateMaterialGoodsReceipt>(
    getUpdateMaterialGoodsReceiptSchema(),
    {
      id: materialGoodsReceiptDetail?.id,
      receiptDate: materialGoodsReceiptDetail?.receiptDate,
      items: [],
    }
  );

  useEffect(() => {
    if (materialGoodsReceiptDetail) {
      setDefaults({
        id: materialGoodsReceiptDetail?.id,
        receiptDate: materialGoodsReceiptDetail?.receiptDate,
        items: materialGoodsReceiptDetail.items.map((x) => ({
          id: x.id,
          materialId: x.materialId,
          unitOfCalculation: x.unitOfCalculation,
          amount: x.amount,
          wareHouse: x.wareHouse,
          brand: x.brand,
          code: x.code,
          supplier: x.supplier,
          document: x.document,
          note: x.note,
          origin: x.origin,
        })),
      });

      if (
        materialGoodsReceiptDetail.items &&
        materialGoodsReceiptDetail.items.length > 0
      ) {
        getControl("items").children.forEach((row: IControl[]) => {
          const idCtr = row.filter((x) => x.name === "id")?.[0];
          const data = materialGoodsReceiptDetail.items.filter(
            (x) => idCtr && x.id === idCtr.value
          )?.[0];

          const materialIdCtr = row.filter((x) => x.name === "materialId")?.[0];
          if (materialIdCtr && data?.material) {
            materialIdCtr.setProp("optionItems", [
              {
                label: createMaterialOptionLabel(data.material),
                value: data.material?.id,
              },
            ]);
          }
        });
      }
    }
  }, [
    controls,
    getControl,
    materialGoodsReceiptDetail,
    materialGoodsReceiptDetail?.id,
    materialGoodsReceiptDetail?.receiptDate,
    materialGoodsReceiptDetail?.items,
    setDefaults,
  ]);

  const saveHandler = useCallback(
    async (data: IUpdateMaterialGoodsReceipt) => {
      try {
        if (!materialGoodsReceiptDetail?.id) return;
        await materialGoodsReceiptBusiness.update(
          materialGoodsReceiptDetail?.id,
          data
        );
        await getMaterialGoodsReceipt();
        setProp("openEdit", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getMaterialGoodsReceipt, materialGoodsReceiptDetail?.id, setProp]
  );

  const itemsControl = useMemo(() => {
    return getControl("items").children;
  }, [getControl]);

  return (
    <DialogForm
      open={openEdit}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Sửa nhập kho</DialogTitle>
      <DialogContent>
        <Stack sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
          {itemsControl && itemsControl.length > 0 && (
            <DynamicFormArray
              children={itemsControl}
              controlSpacing={2}
            ></DynamicFormArray>
          )}
        </Stack>
      </DialogContent>
    </DialogForm>
  );
});
